import * as React from 'react';
import { connect } from 'react-redux';
import { photoCaptureIntelligentViewChangeAction } from '../actions';
import { IntelligentPhotoCaptureTakePhotoView } from '../components';
const mapDispatchToProps = (dispatch) => ({
    onViewChange: (view) => {
        dispatch(photoCaptureIntelligentViewChangeAction(view));
    }
});
const PhotoCaptureTakePhotoViewWrapper = (props) => React.createElement(IntelligentPhotoCaptureTakePhotoView, Object.assign({}, props));
export const ConnectedIntelligentPhotoCaptureTakePhotoView = connect(null, mapDispatchToProps)(PhotoCaptureTakePhotoViewWrapper);
//# sourceMappingURL=ConnectedIntelligentPhotoCaptureTakePhotoView.js.map